/* global axios */
import { msBaseUrl } from './microservicos';

export const pipelineAPI = {
  // ---- Funis -------------------------------------------------------------
  getOverview(accountId) {
    return axios.get(`${msBaseUrl('pipeline', accountId)}/pipelines/overview`);
  },
  getSummary(id, accountId) {
    return axios.get(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${id}/summary`
    );
  },
  createPipeline(data, accountId) {
    return axios.post(`${msBaseUrl('pipeline', accountId)}/pipelines`, data);
  },
  updatePipeline(id, data, accountId) {
    return axios.put(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${id}`,
      data
    );
  },
  deletePipeline(id, accountId) {
    return axios.delete(`${msBaseUrl('pipeline', accountId)}/pipelines/${id}`);
  },
  toggleFavorite(id, accountId) {
    return axios.post(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${id}/favorite`,
      {}
    );
  },
  setAgents(id, agentIds, accountId) {
    return axios.patch(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${id}/agents`,
      { agentIds }
    );
  },
  setInboxes(id, inboxIds, accountId) {
    return axios.patch(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${id}/inboxes`,
      { inboxIds }
    );
  },
  getSettings(id, accountId) {
    return axios.get(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${id}/settings`
    );
  },
  getMetrics(id, accountId, from, to) {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${id}/metrics`,
      { params }
    );
  },
  exportCsv(id, accountId) {
    return axios.get(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${id}/export`,
      {
        responseType: 'blob',
      }
    );
  },
  updateSettings(id, data, accountId) {
    return axios.patch(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${id}/settings`,
      data
    );
  },

  // ---- Etapas ------------------------------------------------------------
  getStages(pipelineId, accountId) {
    return axios.get(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${pipelineId}/stages`
    );
  },
  createStage(pipelineId, data, accountId) {
    return axios.post(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${pipelineId}/stages`,
      data
    );
  },
  updateStage(pipelineId, id, data, accountId) {
    return axios.put(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${pipelineId}/stages/${id}`,
      data
    );
  },
  deleteStage(pipelineId, id, accountId) {
    return axios.delete(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${pipelineId}/stages/${id}`
    );
  },

  // ---- Cards -------------------------------------------------------------
  getCards(accountId, params = {}) {
    return axios.get(`${msBaseUrl('pipeline', accountId)}/cards`, { params });
  },
  // Em qual card e etapa estão as conversas (bolinhas de não lidas do quadro).
  getCardsByConversations(accountId, conversationIds, params = {}) {
    return axios.post(
      `${msBaseUrl('pipeline', accountId)}/cards/by-conversations`,
      { conversationIds },
      { params }
    );
  },
  getCard(id, accountId) {
    return axios.get(`${msBaseUrl('pipeline', accountId)}/cards/${id}`);
  },
  getCardEvents(id, accountId) {
    return axios.get(`${msBaseUrl('pipeline', accountId)}/cards/${id}/events`);
  },
  createCard(data, accountId) {
    return axios.post(`${msBaseUrl('pipeline', accountId)}/cards`, data);
  },
  createCardFromConversation(data, accountId) {
    return axios.post(
      `${msBaseUrl('pipeline', accountId)}/cards/from-conversation`,
      data
    );
  },
  updateCard(id, data, accountId) {
    return axios.patch(`${msBaseUrl('pipeline', accountId)}/cards/${id}`, data);
  },
  moveCard(id, data, accountId) {
    return axios.patch(
      `${msBaseUrl('pipeline', accountId)}/cards/${id}/move`,
      data
    );
  },
  closeCard(id, outcome, accountId) {
    return axios.patch(
      `${msBaseUrl('pipeline', accountId)}/cards/${id}/close`,
      { outcome }
    );
  },
  deleteCard(id, accountId) {
    return axios.delete(`${msBaseUrl('pipeline', accountId)}/cards/${id}`);
  },

  // ---- Webhooks ----------------------------------------------------------
  getWebhooks(accountId) {
    return axios.get(`${msBaseUrl('pipeline', accountId)}/webhooks`);
  },
  createWebhook(data, accountId) {
    return axios.post(`${msBaseUrl('pipeline', accountId)}/webhooks`, data);
  },
  deleteWebhook(id, accountId) {
    return axios.delete(`${msBaseUrl('pipeline', accountId)}/webhooks/${id}`);
  },

  // ---- Produtos ----------------------------------------------------------
  getProducts(pipelineId, accountId, archived) {
    return axios.get(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${pipelineId}/products`,
      {
        params: archived == null ? {} : { archived },
      }
    );
  },
  createProduct(pipelineId, data, accountId) {
    return axios.post(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${pipelineId}/products`,
      data
    );
  },
  updateProduct(pipelineId, id, data, accountId) {
    return axios.put(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${pipelineId}/products/${id}`,
      data
    );
  },
  deleteProduct(pipelineId, id, accountId) {
    return axios.delete(
      `${msBaseUrl('pipeline', accountId)}/pipelines/${pipelineId}/products/${id}`
    );
  },
  getCardProducts(cardId, accountId) {
    return axios.get(
      `${msBaseUrl('pipeline', accountId)}/cards/${cardId}/products`
    );
  },
  addCardProduct(cardId, data, accountId) {
    return axios.post(
      `${msBaseUrl('pipeline', accountId)}/cards/${cardId}/products`,
      data
    );
  },
  updateCardProduct(cardId, itemId, data, accountId) {
    return axios.put(
      `${msBaseUrl('pipeline', accountId)}/cards/${cardId}/products/${itemId}`,
      data
    );
  },
  deleteCardProduct(cardId, itemId, accountId) {
    return axios.delete(
      `${msBaseUrl('pipeline', accountId)}/cards/${cardId}/products/${itemId}`
    );
  },
};
